import { useGlobalStore } from "controller";
import { dayjs } from "utilz/dayjs";

const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const;

export type TimeOfDay = "morning" | "afternoon" | "evening" | "night";

export interface AiHomeTimeContext {
  time_of_day: TimeOfDay;
  day_of_week: (typeof DAYS)[number];
  local_hour: number;
}

const toTimeOfDay = (hour: number): TimeOfDay => {
  if (hour >= 5 && hour <= 11) return "morning";
  if (hour >= 12 && hour <= 16) return "afternoon";
  if (hour >= 17 && hour <= 20) return "evening";
  return "night";
};

export const aiHomeTimeContext = (): AiHomeTimeContext => {
  const timezone = useGlobalStore.getState().timezone;
  const now = timezone ? dayjs().tz(timezone) : dayjs();
  const hour = now.hour();

  return {
    time_of_day: toTimeOfDay(hour),
    day_of_week: DAYS[now.day()],
    local_hour: hour,
  };
};
